<template>
        <yandex-map
            :coords="coords"
            :zoom="zoom"
            :controls="controls"
            :behaviors="behaviors"
            @map-was-initialized="initHandler"
            v-if="list">
            <ymap-marker v-for="item in markers"
                         marker-type="placemark"
                         :key="item.id"
                         :marker-id="item.id"
                         :coords="item.coordinates"
                         :icon="markerIcon"
                         :balloon="{body: balloonContent(item)}"
                         :hint-content="hintContent(item)"
                         cluster-name="offices"
                         @click="setOffice(item)"
            />
        </yandex-map>
</template>

<script>
    export default {
        props: ['list'],
        data() {
            return {
                map: null,
                coords: [55.769428, 37.598959],
                zoom: 16,
                bounds: 'sync',
                controls: ['fullscreenControl', 'geolocationControl', 'zoomControl'],
                behaviors: ['drag'],
                markerIcon: {
                    layout: 'default#image',
                    imageHref: '/img/map-marker.png',
                    imageSize: [44, 71],
                    imageOffset: [-27, -67],
                }
            }
        },
        computed: {
          markers() {
              return this.list.map(i => {
                  if(typeof i.coordinates == 'string') {
                      i.coordinates = i.coordinates.split(',');
                  }
                  console.log(i.coordinates);
                  return i;
              });
          }
        },
        /*watch: {
            markers: {
                deep: true,
                handler() {
                    let coords = this.markers.map(i => i.coordinates);
                    this.map.setBounds(ymaps.util.bounds.fromPoints(coords));
                    this.map.setZoom(16);
                }
            }
        },*/
        methods: {
            hintContent: function (item) {
                let content = item.name + ':';
                if (item.address) content += ' Адрес: ' + item.address;
                if (item.worktimeText) content += ' Режим работы: ' + item.work_time;
                if (item.phones) content += ' Тел: ' + item.phone;
                return content;
            },
            balloonContent: function (item) {
                let content = item.name + ':';
                if (item.address) content += ' Адрес: ' + item.address;
                if (item.worktimeText) content += ' Режим работы: ' + item.work_time;
                if (item.phones) content += ' Тел: ' + item.phone;
                return content;
            },
            initHandler(map) {
                let coords = this.markers.map(i => i.coordinates);
                map.setBounds(ymaps.util.bounds.fromPoints(coords));
                map.setZoom(16);
                this.map = map;
            },
            setOffice(office) {
                //
            }
        },
    }
</script>
